import RibbonPlugin from '../plugin/RibbonPlugin';
import updateCachedFormatViewState from '../actions/updateCachedFormatViewState';
import {
    getFormatState,
    setBackgroundColor,
    setFontName,
    setFontSize,
    setTextColor,
    toggleBold,
    toggleItalic,
    toggleUnderline,
} from 'roosterjs-editor-api';
import { ChangeSource } from 'roosterjs-editor-types';

export default function formatPainterFinish(plugin: RibbonPlugin) {
    let editor = plugin.getEditor();
    if (!editor) {
        return;
    }
    let range = editor.getSelectionRange();
    let cachedFormat = plugin.getFormatState().formatPainterFormat;

    if (!range || !cachedFormat) {
        return;
    }

    // If the current range is collapsed, select the node at cursor
    if (range.collapsed) {
        range.selectNode(editor.getElementAtCursor());
    }

    let currentFormat = getFormatState(editor);
    editor.addUndoSnapshot(() => {
        setFontName(editor, cachedFormat.fontName || currentFormat.fontName);
        setFontSize(editor, cachedFormat.fontSize || currentFormat.fontSize);
        setTextColor(editor, cachedFormat.textColor || currentFormat.textColor);
        setBackgroundColor(editor, cachedFormat.backgroundColor || currentFormat.backgroundColor);
        toggleBold(editor);
        toggleItalic(editor);
        toggleUnderline(editor);
        if (cachedFormat.isBold == currentFormat.isBold) {
            toggleBold(editor);
        }
        if (cachedFormat.isItalic == currentFormat.isItalic) {
            toggleItalic(editor);
        }
        if (cachedFormat.isUnderline == currentFormat.isUnderline) {
            toggleUnderline(editor);
        }
    }, ChangeSource.Format);
    updateCachedFormatViewState(plugin.getFormatState(), null /*formatState*/);
}
